<template>
  <el-select
    :key="actualKey"
    v-model="value"
    placeholder="Tipo de Objetivo"
    @change="OnTypeChange"
    size="mini"
    clearable
    :disabled="disabled"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "TypeStrategicFilter",
  props: {
    initialValue: {
      type: Number
    },
    currentEmployeePosition: {
      type: Number,
      default: 0,
      required: false
    },
    isDisable: {
      type: Boolean,
      default: false,
      required: false
    },
    actualKey: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      options: [
        // { value: null, label: "Todos" },
        { value: 2, label: "Estratégico" },
        { value: 1, label: "Operacional" }
      ],
      value: null,
      disabled: false,
      filteredOptions: []
    };
  },
  computed: {
    // filteredOptions() {
    //   let optionsFiltered;
    //   console.log("currentUser: ", this.currentEmployeePosition, "\noptions: ", this.options)
    //   if (this.currentEmployeePosition === 0 || this.currentEmployeePosition === 16 ) {
    //     optionsFiltered = this.options;
    //   }
    //   else {
    //     optionsFiltered = this.options.filter((o) => o.label !== "Estratégico");
    //   }
    //   return optionsFiltered;
    // }
  },
  mounted() {
    this.value = this.initialValue;
    this.disabled = this.isDisable;
  },
  updated() {
    //this.value = this.initialValue;
    this.disabled = this.isDisable;
  },
  methods: {
    OnTypeChange(value) {
      this.value = value;
      this.$emit("TypeStrategicFilterChange", value);
    }
  },
  watch: {
    initialValue(initialValue) {
      this.value = initialValue;
    },
    // currentEmployeePosition(currentEmployeePosition){
    //   console.log("currentEmployeePosition en watch: ", currentEmployeePosition)
    //    let optionsFiltered;
    //   console.log("currentUser: ", this.currentEmployeePosition, "\noptions: ", this.options)
    //   if (this.currentEmployeePosition === 0 || this.currentEmployeePosition === 16 ) {
    //     optionsFiltered = this.options;
    //   }
    //   else {
    //     optionsFiltered = this.options.filter((o) => o.label !== "Estratégico");
    //   }
    //   this.options = optionsFiltered;

    // },
    isDisable(isDisable) {
      this.disabled = isDisable;
    }
  }
};
</script>

<style lang="scss" scoped></style>
